import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3df5ebe5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "statusText"
}
const _hoisted_2 = {
  key: 0,
  class: "arrowIcon"
}

import { Skeletor } from 'vue-skeletor';
import { Port } from '@/types';
import { ServiceStatusType } from '../../types/ServiceStatusType';
import { GetServiceStatus } from '../ServiceStatus/index';
import { RouteDetail } from '..';
import { Icon } from '../../Atoms';
import 'vue-skeletor/dist/vue-skeletor.css';


export default /*#__PURE__*/_defineComponent({
  __name: 'RouteItem',
  props: {
    status: {},
    ports: {},
    destinationName: {},
    clickHandler: { type: Function },
    isArrowHidden: { type: Boolean },
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "routeItem",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickHandler && _ctx.clickHandler(...args)))
  }, [
    _createVNode(_unref(RouteDetail), {
      status: _ctx.status,
      ports: _ctx.ports,
      "destination-name": _ctx.destinationName,
      "is-loading": _ctx.isLoading
    }, {
      infoCard: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["infoCard", _ctx.status])
        }, [
          (!_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(GetServiceStatus)(_ctx.status).text), 1))
            : (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_unref(Skeletor), { key: 1 }))
              : _createCommentVNode("", true),
          _createVNode(_unref(Icon), { "icon-name": "info" })
        ], 2)
      ]),
      _: 1
    }, 8, ["status", "ports", "destination-name", "is-loading"]),
    (!_ctx.isArrowHidden)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(Icon), { "icon-name": "redLink" })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})